import React from 'react'
import MusicSongFeed from './MusicSongFeed'
import { mySongsUrl } from './radioArtistsModel'
import { getJson } from './radioArtistsParts'

// Music's My Music tab: the viewer's own songs, newest first, aired or not.
export default function MyMusic() {
    return (
        <MusicSongFeed
            queryKey={['myMusic']}
            fetchPage={page => getJson(mySongsUrl(page))}
            source="my_music"
            emptyText="No songs yet. Post one with New Music."
            testId="my-music"
        />
    )
}
